import PBService from "@irati/utils/services"
import {
  ProductSettings,
  UpdateProductSettingsPerks,
  UpdateProductSettingsMedical,
  UpdateProductSettingsRecognition,
  MutationUpdatePermissionsProductSettingsPerksArgs,
  MutationUpdatePermissionsProductSettingsRecognitionArgs,
  MutationUpdatePermissionsProductSettingsMedicalArgs
} from "@irati/types/ops"
import client, {MutationOptions, QueryOptions} from "@irati/utils/services/apollo"
import updatePerkSettingsMutation, {updatePerkSettingsKey} from "./mutations/updatePerks"
import updateRecognitionSettingsMutation, {updateRecognitionSettingsKey} from "./mutations/updateRecognition"
import updateMedicalSettingsMutation, {updateMedicalSettingsKey} from "./mutations/updateMedical"
import productSettingsTeamQuery, {productSettingsTeamKey} from "./queries/productSettings"

class ProductSettingsService extends PBService {
  updatePerkSettings(
    businessId: string,
    teamId: string,
    payload: UpdateProductSettingsPerks,
    options: MutationOptions = {}
  ): Promise<ProductSettings> {
    const variables: MutationUpdatePermissionsProductSettingsPerksArgs = {
      businessId,
      teamId,
      data: payload
    }

    return client.mutate({...options, mutation: updatePerkSettingsMutation, variables}).then(({data}) => {
      return data[updatePerkSettingsKey]
    })
  }

  updateRecognitionSettings(
    businessId: string,
    teamId: string,
    payload: UpdateProductSettingsRecognition,
    options: MutationOptions = {}
  ): Promise<ProductSettings> {
    const variables: MutationUpdatePermissionsProductSettingsRecognitionArgs = {
      businessId,
      teamId,
      data: payload
    }

    return client.mutate({...options, mutation: updateRecognitionSettingsMutation, variables}).then(({data}) => {
      return data[updateRecognitionSettingsKey]
    })
  }

  updateMedicalSettings(
    businessId: string,
    teamId: string,
    payload: UpdateProductSettingsMedical,
    options: MutationOptions = {}
  ): Promise<ProductSettings> {
    const variables: MutationUpdatePermissionsProductSettingsMedicalArgs = {
      businessId,
      teamId,
      data: payload
    }

    return client.mutate({...options, mutation: updateMedicalSettingsMutation, variables}).then(({data}) => {
      return data[updateMedicalSettingsKey]
    })
  }

  get(businessId: string, teamId: string, options: QueryOptions = {}): Promise<ProductSettings> {
    const variables = {businessId, teamId}
    return client.query({...options, query: productSettingsTeamQuery, variables}).then(({data}) => data[productSettingsTeamKey])
  }
}

const productSettingsService = new ProductSettingsService({errorHandlers: []})

export default productSettingsService
